import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route //////////////
export const masterRoute = createRoute({
    path: "/setting",
    name: "menu.master",
    icon: "settings",
    accCode: "pengaturan",
});

export const mBankAccRoute = createRoute({
    path: `${masterRoute.path}/bankAccount`,
    name: "master_bankaccount.",
    accCode: "pengaturan_rekening_bank",
    parentCode: masterRoute.accCode,
});

export const mCategoryRoute = createRoute({
    path: `${masterRoute.path}/category`,
    name: "common.category",
    accCode: "pengaturan_kategori",
    parentCode: masterRoute.accCode,
});

export const mCourierRoute = createRoute({
    path: `${masterRoute.path}/courier`,
    name: "common.courier",
    accCode: "pengaturan_kurir",
    parentCode: masterRoute.accCode,
});

export const mCustomerRoute = createRoute({
    path: `${masterRoute.path}/customer`,
    name: "common.customer",
    accCode: "pengaturan_pelanggan",
    parentCode: masterRoute.accCode,
});

export const mSupplierRoute = createRoute({
    path: `${masterRoute.path}/supplier`,
    name: "common.supplier",
    accCode: "pengaturan_pemasok",
    parentCode: masterRoute.accCode,
});

export const mConvertionRoute = createRoute({
    path: `${masterRoute.path}/conversion`,
    name: "master_convertion.",
    accCode: "pengaturan_konversi_barang",
    parentCode: masterRoute.accCode,
});

export const mPaymentMethodRoute = createRoute({
    path: `${masterRoute.path}/paymethod`,
    name: "master_payment_method.",
    accCode: "pengaturan_metode_pembayaran",
    parentCode: masterRoute.accCode,
});

export const mTNCRoute = createRoute({
    path: `${masterRoute.path}/termAndCondition`,
    name: "master_tncsetting.",
    accCode: "pengaturan_kebijakan_dan_ketentuan",
    parentCode: masterRoute.accCode,
});

export const mUnitRoute = createRoute({
    path: `${masterRoute.path}/unit`,
    name: "common.unit",
    accCode: "pengaturan_satuan",
    parentCode: masterRoute.accCode,
});

export const mPriceTierRoute = createRoute({
    path: `${masterRoute.path}/price_tier`,
    name: "master_price_tier.",
    accCode: "pengaturan_tingkat_harga",
    parentCode: masterRoute.accCode,
});

export const mSalesRoute = createRoute({
    path: `${masterRoute.path}/sales`,
    name: "master_sales.",
    accCode: "pengaturan_sales",
    parentCode: masterRoute.accCode,
});

export const mReturnCusTypeRoute = createRoute({
    path: `${masterRoute.path}/return_customer_type`,
    name: "master_return_customer_type.",
    accCode: "",
    parentCode: masterRoute.accCode,
});

export const mOtherCostRoute = createRoute({
    path: `${masterRoute.path}/other_cost`,
    name: "master_other_cost.",
    accCode: "",
    parentCode: masterRoute.accCode,
});

// finance
export const mFinanceRoute = createRoute({
    path: `${masterRoute.path}/fiance`,
    name: "master_finance.",
    accCode: "pengaturan_keuangan",
    parentCode: masterRoute.accCode,
});

export const mFinanceCategoryRoute = createRoute({
    path: `${masterRoute.path}/fiance-category`,
    name: "master_finance_category.",
    accCode: "pengaturan_kategori_keuangan",
    parentCode: masterRoute.accCode,
});

// warehouse
export const mWarehouseRoute = createRoute({
    path: `${masterRoute.path}/warehouse`,
    name: "master_whssetting.",
    accCode: "pengaturan_gudang",
    parentCode: masterRoute.accCode,
});

export const mWarehouseAddressCreateRoute = createRoute({
    path: `${mWarehouseRoute.path}/create`,
    name: "master_whssetting.add",
    accCode: "pengaturan_gudang",
    parentCode: masterRoute.accCode,
    action: "create",
    redirectTo: mWarehouseRoute.path,
});

export const mWarehouseAddressEditRoute = createRoute({
    path: `${mWarehouseRoute.path}/edit`,
    name: "master_whssetting.edit",
    accCode: "pengaturan_gudang",
    parentCode: masterRoute.accCode,
    action: "edit",
    redirectTo: mWarehouseRoute.path,
});

export const mWarehouseStorageRoute = createRoute({
    path: `${mWarehouseRoute.path}/storage`,
    name: "master_storage.",
    accCode: "pengaturan_ruang_penyimpanan",
    parentCode: masterRoute.accCode,
});

// user
export const mUserRoute = createRoute({
    path: `${masterRoute.path}/user`,
    name: "master_user.",
    accCode: "pengaturan_pengguna",
    parentCode: masterRoute.accCode,
});

export const mUserCreateRoute = createRoute({
    path: `${mUserRoute.path}/create`,
    name: "master_user.add",
    accCode: "pengaturan_pengguna",
    parentCode: masterRoute.accCode,
    action: "create",
    redirectTo: mUserRoute.path,
});

export const mUserEditRoute = createRoute({
    path: `${mUserRoute.path}/edit`,
    name: "master_user.edit",
    accCode: "pengaturan_pengguna",
    parentCode: masterRoute.accCode,
    action: "edit",
    redirectTo: mUserRoute.path,
});

// goods
export const mGoodsRoute = createRoute({
    path: `${masterRoute.path}/goods`,
    name: "common.goods",
    accCode: "pengaturan_barang",
    parentCode: masterRoute.accCode,
});

export const mGoodsBarcodeRoute = createRoute({
    path: `${mGoodsRoute.path}/barcode`,
    name: "master_goods.barcode",
    accCode: "pengaturan_barang",
    parentCode: masterRoute.accCode,
});

export const mGoodsCreateRoute = createRoute({
    path: `${mGoodsRoute.path}/create`,
    name: "master_goods.add",
    accCode: "pengaturan_barang",
    parentCode: masterRoute.accCode,
    action: "create",
    redirectTo: mGoodsRoute.path,
});

export const mGoodsEditRoute = createRoute({
    path: `${mGoodsRoute.path}/edit`,
    name: "master_goods.edit",
    accCode: "pengaturan_barang",
    parentCode: masterRoute.accCode,
    action: "edit",
    redirectTo: mGoodsRoute.path,
});

export const mGoodsPriceRoute = createRoute({
    path: `${mGoodsRoute.path}/price`,
    name: "master_goods.price",
    accCode: "pengaturan_barang",
    parentCode: masterRoute.accCode,
});

export const mGoodsUploadRoute = createRoute({
    path: `${mGoodsRoute.path}/upload`,
    name: "master_goods.upload",
    accCode: "pengaturan_barang",
    parentCode: masterRoute.accCode,
});

export const mGoodsViewRoute = createRoute({
    path: `${mGoodsRoute.path}/view`,
    name: "master_goods.view",
    accCode: "pengaturan_barang",
    parentCode: masterRoute.accCode,
});

// grouping
export const mGroupingRoute = createRoute({
    path: `${masterRoute.path}/grouping`,
    name: "menu.groups",
    accCode: "",
    parentCode: masterRoute.accCode,
});

export const mGroupingCreateRoute = createRoute({
    path: `${mGroupingRoute.path}/create`,
    name: "master_groups.add",
    accCode: "",
    parentCode: masterRoute.accCode,
    action: "create",
    redirectTo: mGroupingRoute.path,
});

export const mGroupingEditRoute = createRoute({
    path: `${mGroupingRoute.path}/edit`,
    name: "master_groups.edit",
    accCode: "",
    parentCode: masterRoute.accCode,
    action: "edit",
    redirectTo: mGroupingRoute.path,
});

// profile
export const mProfileRoute = createRoute({
    path: `${masterRoute.path}/profile`,
    name: "common.profile",
    accCode: "pengaturan_profil",
    parentCode: masterRoute.accCode,
});

export const mProfileCreateRoute = createRoute({
    path: `${mProfileRoute.path}/create`,
    name: "master_profile.add",
    accCode: "pengaturan_profil",
    parentCode: masterRoute.accCode,
    action: "create",
    redirectTo: mProfileRoute.path,
});

export const mProfileEditRoute = createRoute({
    path: `${mProfileRoute.path}/edit`,
    name: "master_profile.edit",
    accCode: "pengaturan_profil",
    parentCode: masterRoute.accCode,
    action: "edit",
    redirectTo: mProfileRoute.path,
});

// process
export const mProcessRoute = createRoute({
    path: `${masterRoute.path}/production`,
    name: "master_process.",
    accCode: "pengaturan_proses",
    parentCode: masterRoute.accCode,
});

export const mProcessCreateRoute = createRoute({
    path: `${mProcessRoute.path}/add`,
    name: "master_process.add",
    accCode: "pengaturan_proses",
    parentCode: masterRoute.accCode,
    action: "create",
    redirectTo: mProcessRoute.path,
});

export const mProcessEditRoute = createRoute({
    path: `${mProcessRoute.path}/edit`,
    name: "master_process.edit",
    accCode: "pengaturan_proses",
    parentCode: masterRoute.accCode,
    action: "edit",
    redirectTo: mProcessRoute.path,
});

// attribute
export const mAttributeRoute = createRoute({
    path: `${masterRoute.path}/attribute`,
    name: "master_attribute.",
    accCode: "pengaturan_atribut",
    parentCode: masterRoute.accCode,
});

// item tag
export const mItemTagRoute = createRoute({
    path: `${masterRoute.path}/itemtag`,
    name: "master_itemtag.",
    accCode: "pengaturan_tag_barang",
    parentCode: masterRoute.accCode,
});

// end route /////////////////////

// component
const Master = lazy(() => import("../page/master/Master"));
const MUser = lazy(() => import("../page/master/user/MasterUser"));
const MUserForm = lazy(() => import("../page/master/user/form/MasterUserForm"));
const MUnitCategory = lazy(() => import("../page/master/unit_category/MasterUnitCategory"));
const MSupplier = lazy(() => import("../page/master/supplier/MasterSupplier"));
const MCustomer = lazy(() => import("../page/master/customer/MasterCustomer"));
const MSales = lazy(() => import("../page/master/sales/MasterSales"));
const MReturnCusType = lazy(() => import("../page/master/return_customer_type/MasterReturnCustomerType"));
const MOtherCost = lazy(() => import("../page/master/other_cost/MasterOtherCost"));

const MGoods = lazy(() => import("../page/master/goods/MasterGoods"));
const MGoodsView = lazy(() => import("../page/master/goods/detail/MasterGoodsView"));
const MGoodsForm = lazy(() => import("../page/master/goods/form/MasterGoodsForm"));
const MGoodsUploadForm = lazy(() => import("../page/master/goods/MasterGoodsUploadForm"));
const MGoodsPriceForm = lazy(() => import("../page/master/goods/price/MasterGoodsPrice"));
const MGoodsBarcodeRoute = lazy(() => import("../page/master/goods/barcode/MasterGoodsBarcode"));

const MProfile = lazy(() => import("../page/master/profile/MasterProfile"));
const MProfileForm = lazy(() => import("../page/master/profile/form/MasterProfileForm"));

// const MGrouping = lazy(() => import("../page/master/grouping/MasterGrouping"));
// const MGroupingForm = lazy(() => import("../page/master/grouping/form/MasterGroupingForm"));

const MConversion = lazy(() => import("../page/master/conversion/MasterConversion"));
const MTNCSetting = lazy(() => import("../page/master/tnc_setting/MasterTNCSetting"));
const MBankAccount = lazy(() => import("../page/master/bank_account/MasterBankAccount"));
const MPaymentMethod = lazy(() => import("../page/master/payment_method/MasterPaymentMethod"));

const MFinance = lazy(() => import("../page/master/finance/MasterFinance"));
const MFinanceCategory = lazy(() => import("../page/master/finance_category/MasterFinanceCategory"));

const MProcess = lazy(() => import("../page/master/process/MasterProcess"));
const MProcessForm = lazy(() => import("../page/master/process/form/MasterProcessForm"));
const MCourier = lazy(() => import("../page/master/courier/MasterCourier"))
const MAttribute = lazy(() => import("../page/master/attribute/MasterAttribute"))
const MItemTag = lazy(() => import("../page/master/item_tag/MasterItemTag"))
const MPriceTier = lazy(() => import("../page/master/price_tier/MasterPriceTier"))

const MWarehouse = lazy(() => import("../page/master/warehouse/MasterWarehouse"));
const MWarehouseAddressForm = lazy(() => import("../page/master/warehouse/MasterWarehouseAddressForm"));
const MWarehouseStorage = lazy(() => import("../page/master/warehouse/storage/MasterWarehouseStorage"));
// end component

export const masterListRoutes = [
    mUserRoute,
    mCourierRoute,
    mSalesRoute,
    mCustomerRoute,
    mSupplierRoute,
    mGoodsRoute,
    mProfileRoute,

    // mGroupingRoute,

    mConvertionRoute,
    mTNCRoute,
    mBankAccRoute,
    mPaymentMethodRoute,
    mProcessRoute,

    // mPOFeeRoute,

    mFinanceRoute,
    mFinanceCategoryRoute,
    mWarehouseRoute,
    mUnitRoute,
    mCategoryRoute,
    mAttributeRoute,
    mItemTagRoute,
    mPriceTierRoute,
    mReturnCusTypeRoute,
    mOtherCostRoute,
];

export const masterMutationRoute = [
    mGoodsCreateRoute, mGoodsEditRoute, mGoodsUploadRoute, mGoodsPriceRoute, mGoodsBarcodeRoute, mGoodsViewRoute,
    mGroupingCreateRoute, mGroupingEditRoute,
    mProfileCreateRoute, mProfileEditRoute,
    mProcessCreateRoute, mProcessEditRoute,
    mUserCreateRoute, mUserEditRoute,
    mWarehouseAddressCreateRoute, mWarehouseAddressEditRoute,
    mWarehouseStorageRoute,
]

export const masterRoutes = {
    element: <Master />,
    children: addHandleRoute([
        { ...mAttributeRoute, element: <MAttribute /> },
        { ...mItemTagRoute, element: <MItemTag /> },
        { ...mUserRoute, element: <MUser /> },
        { ...mCourierRoute, element: <MCourier /> },
        { ...mSalesRoute, element: <MSales /> },
        { ...mUserCreateRoute, element: <MUserForm type="add" /> },
        { ...mUserEditRoute, element: <MUserForm type="edit" /> },
        { ...mUnitRoute, element: <MUnitCategory type="unit" /> },
        { ...mCategoryRoute, element: <MUnitCategory type="category" /> },
        { ...mGoodsRoute, element: <MGoods /> },
        { ...mGoodsViewRoute, element: <MGoodsView /> },
        { ...mGoodsCreateRoute, element: <MGoodsForm type="add" /> },
        { ...mGoodsEditRoute, element: <MGoodsForm type="edit" /> },
        { ...mGoodsUploadRoute, element: <MGoodsUploadForm /> },
        { ...mGoodsPriceRoute, element: <MGoodsPriceForm /> },
        { ...mGoodsBarcodeRoute, element: <MGoodsBarcodeRoute /> },
        { ...mCustomerRoute, element: <MCustomer /> },
        { ...mSupplierRoute, element: <MSupplier /> },
        { ...mProfileRoute, element: <MProfile /> },
        { ...mProfileCreateRoute, element: <MProfileForm type="add" /> },
        { ...mProfileEditRoute, element: <MProfileForm type="edit" /> },
        // { ...mGroupingRoute, element: <MGrouping /> },
        // { ...mGroupingCreateRoute, element: <MGroupingForm type="add" /> },
        // { ...mGroupingEditRoute, element: <MGroupingForm type="edit" /> },
        { ...mConvertionRoute, element: <MConversion /> },
        { ...mTNCRoute, element: <MTNCSetting /> },
        { ...mBankAccRoute, element: <MBankAccount /> },
        { ...mPaymentMethodRoute, element: <MPaymentMethod /> },
        { ...mProcessRoute, element: <MProcess /> },
        { ...mProcessCreateRoute, element: <MProcessForm /> },
        { ...mProcessEditRoute, element: <MProcessForm /> },
        { ...mFinanceRoute, element: <MFinance /> },
        { ...mFinanceCategoryRoute, element: <MFinanceCategory /> },
        { ...mWarehouseRoute, element: <MWarehouse /> },
        { ...mPriceTierRoute, element: <MPriceTier /> },
        { ...mWarehouseAddressCreateRoute, element: <MWarehouseAddressForm type='add' /> },
        { ...mWarehouseAddressEditRoute, element: <MWarehouseAddressForm type='edit' /> },
        { ...mWarehouseStorageRoute, element: <MWarehouseStorage /> },
        { ...mReturnCusTypeRoute, element: <MReturnCusType /> },
        { ...mOtherCostRoute, element: <MOtherCost /> },
    ]),
};